export const fieldLabel = ` dark:text-white/80 font-medium`;
export const fieldDescription = `text-xs text-gray-500 dark:text-white/50 leading-tight`;
